function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M497.01,203c8.284,0,15-6.716,15-15s-6.716-15-15-15h-31v-30h31c8.284,0,15-6.716,15-15s-6.716-15-15-15h-31V60  c0-33.084-26.916-60-60-60s-60,26.916-60,60v53h-30V60c0-33.084-26.916-60-60-60s-60,26.916-60,60v53h-30V60  c0-33.084-26.916-60-60-60s-60,26.916-60,60v53H15.007c-8.284,0-15,6.716-15,15s6.716,15,15,15h31.002v30H15.007  c-8.284,0-15,6.716-15,15s6.716,15,15,15h31.002v149H15.007c-8.284,0-15,6.716-15,15s6.716,15,15,15h31.002v30H15.007  c-8.284,0-15,6.716-15,15s6.716,15,15,15h31.002v55.017c0,8.284,6.716,15,15,15h90c8.284,0,15-6.716,15-15V442h30v54.99  c0,8.284,6.716,15,15,15h90c8.284,0,15-6.716,15-15V442h30v54.99c0,8.284,6.716,15,15,15h90c8.284,0,15-6.716,15-15V442h31  c8.284,0,15-6.716,15-15s-6.716-15-15-15h-31v-30h31c8.284,0,15-6.716,15-15s-6.716-15-15-15h-31V203H497.01z M316.009,203h30v149  h-30V203z M346.009,143v30h-30v-30H346.009z M166.009,203h30v149h-30V203z M196.009,143v30h-30v-30H196.009z M136.009,482.017h-60  V60c0-16.542,13.458-30,30-30s30,13.458,30,30V482.017z M166.009,412v-30h30v30H166.009z M286.009,481.99h-60V60  c0-16.542,13.458-30,30-30s30,13.458,30,30V481.99z M316.009,412v-30h30v30H316.009z M436.009,481.99h-60V60  c0-16.542,13.458-30,30-30s30,13.458,30,30V481.99z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.017 512.017",
    style: {
      "enableBackground": "new 0 0 512.017 512.017"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/fence.6a8ab134.svg";
export { SvgComponent as ReactComponent };